<template>
	<div>
		<div v-if="$vuetify.breakpoint.xs">
			<div v-if="btn_visible && !saveAs" class="search-jobs-xs" @click="onClickBtn">
				<Search class="icon" color="#FFFFFF" width="14" hight="14"/>
				<div>Find Jobs</div>
			</div>
			<div v-else class="find-jobs-xs">
				<CloseIcon v-if="close_show" class="close" width="14" hight="14" @click="onClose"/>
				<v-select
					v-model="select"
					class="search-select-xs"
					placeholder="Search category"
					:items="items"
					item-text="text"
					item-value="value"
					append-icon=""
					prepend-inner-icon="mdi-chevron-down"
					outlined
					dense
					hide-details
					background-color="#FFFFFF"
				></v-select>
				<v-text-field
					v-model="input_text"
					class="search-input-sx"
					placeholder="Type to search..."
					outlined
					hide-details
					dense
					background-color="#FFFFFF"
				></v-text-field>
				<v-btn
					class="search-bnt-xs"
					elevation="0"
					min-height="40"
					color="#00AAFD"
					:disabled="select.length === 0 || input_text.length === 0"
					@click="onClick"
				>
					Find Jobs
				</v-btn>
				<div v-if="saveAs" class="save-as-worklist mt-2" @click="onSaveAsBtn">
					<Save width="20" hight="20" color="#00AAFD" class="mr-1"/>
					Save as Worklist
				</div>
			</div>
		</div>
		<div v-if="$vuetify.breakpoint.smAndUp" class="search-jobs">
			<div class="search-jobs-item">
				<v-select
					v-model="select"
					class="search-select rounded-tr-0 rounded-br-0"
					placeholder="Search category"
					:items="items"
					item-text="text"
					item-value="value"
					append-icon=""
					prepend-inner-icon="mdi-chevron-down"
					outlined
					dense
					hide-details
					background-color="#FFFFFF"
				></v-select>
				<v-text-field
					v-model="input_text"
					class="search-input rounded-0"
					placeholder="Type to search..."
					outlined
					hide-details
					dense
					background-color="#FFFFFF"
				></v-text-field>
				<v-btn
					class="search-bnt rounded-tl-0 rounded-bl-0"
					elevation="0"
					min-height="40"
					color="#00AAFD"
					:disabled="select.length === 0 || input_text.length === 0"
					@click="onClick"
				>
					Find Jobs
				</v-btn>
				<div v-if="saveAs" class="save-as-worklist ml-3" @click="onSaveAsBtn">
					<Save width="20" hight="20" color="#00AAFD" class="mr-1"/>
					Save as Worklist
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Save from "@/components/icons/save";
import Search from "@/components/icons/show_search";
import CloseIcon from '@/components/icons/close';

import config from "@/config.js";

export default {
	name: 'searchBar',
	props: {
		saveAs: {
			type: Boolean,
			default: false,
		},
		close_show: {
			type: Boolean,
			default: true,
		},
		params: {
			type: Object,
			default: () => {},
		},
	},
	components: {
		Save, Search, CloseIcon
	},
	data() {
		return {
			items: config.search_type,
			select: '',
			input_text: '',
			btn_visible: true,
		}
	},
	watch: {
		params() {
			if (this.params && (Object.keys(this.params).length  === 2)) {
				this.input_text = this.params.value;
				this.select = this.params.key;
			} else {
				this.input_text = '';
				this.select = '';
			}
		}	
	},
	methods: {
		async onClick() {
			const param = {};
			param['key'] = this.select;
			param['value'] = this.input_text;

			this.$emit('search', param);
		},
		onClickBtn() {
			this.btn_visible = false;
		},
		onClose() {
			this.btn_visible = true;
		},
		onSaveAsBtn() {
			this.$emit('save-worklist');
		},
	}
}
</script>
<style lang="scss" scoped>
.search-jobs-xs {
	margin-top: 12px;
	margin-left: 12px;
	width: 176px;
	height: 36px;
	display: flex;
	flex-flow: row nowrap;
	justify-content: center;
	align-items: center;
	background: #00AAFD;
	border-radius: 4px;
	color: #FFFFFF;
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 36px;
}
.find-jobs-xs {
	background: #DCDCDC;
	padding: 12px 12px;
}
.close {
	position: relative;
	float: right;
	&:hover {
		cursor: pointer;
	}
}
.icon {
	width: 14px;
	height: 14px;
	color: #FFFFFF;
	margin-right: 12px;
}
.search-jobs {
  padding: 20px 25px;
  margin: 10px 0;
  background: #DCDCDC;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
}
.search-jobs-item {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
}
.search-input {
  width: 50%;
  background: #DCDCDC;
}
.search-input-sx {
  width: 100%;
  background: #DCDCDC;
	margin: 8px 0;
}
.search-select {
  width: 30%;
}
.search-select-xs {
  width: 100%;
	margin: 8px 0;
}
.search-bnt {
  width: 20%;
}
.search-bnt-xs {
	width: 100%;
}
.search-text {
  color: #2196F3;
  text-decoration: underline;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
	&:hover {
		cursor: pointer;
	}
}
.search-text-xs {
  text-align: center;
}


.save-as-worklist {
	display: flex;
	flex-flow: row nowrap;
	justify-content: center;
	align-items: center;
	padding: 0 14px;
	border: 1px solid #00AAFD;
	border-radius: 4px;
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 36px;
	color: #00AAFD;
	white-space: nowrap;
	&:hover {
		cursor: pointer;
	}
}

.theme--light.v-btn {
  color: #FFFFFF;
}
</style>